<template>
  <div>
    <Slidercomponent :lista="listaprops" />
  </div>
</template>

<script>
import Slidercomponent from "@/components/Slidercomponent.vue";

export default {
  name: "Glomma",
  components: {
    Slidercomponent
  },
  data() {
    return {
      listaprops: [
        {
          id: 0,
          rubrik: "Glomma",
          text:
            "I have many loves and Fly-Fishing is one of them; it brings peace and harmony to my being, which I can then pass on to others - Sue Kreutzer",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_031400.jpg"
        },
        {
          id: 1,
          rubrik: "Glomma",
          text:
            "A trout is a moment of beauty known only to those who seek it. - Arnold Gingrich",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_00003_2.jpg"
        },
        {
          id: 2,
          rubrik: "Glomma",
          text:
            "The two best times to fish is when it's rainin' and when it ain't. - Patrick F. McManus",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_00010.jpg"
        },
        {
          id: 3,
          rubrik: "Glomma",
          text:
            "Calling Fly-Fishing a hobby is like calling Brain Surgery a job. - Paul Schullery",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_000440.jpg"
        },
        {
          id: 4,
          rubrik: "Glomma",
          text: "Linnaea borealis",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma-035.jpg"
        },
        {
          id: 5,
          rubrik: "Glomma",
          text:
            "There's a fine line between fishing and standing on the shore like an idiot. - Steven Wright",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_221631.jpg"
        },
        {
          id: 6,
          rubrik: "Glomma",
          text: "Strömmens dam",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_00009_2.jpg"
        },
        {
          id: 7,
          rubrik: "Glomma",
          text:
            "The best time to go fishing is when you can get away. - Robert Traver",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_142625.jpg"
        },
        {
          id: 8,
          rubrik: "Glomma",
          text:
            "O, sir, doubt not that Angling is an art; is it not an art to deceive a trout with an artificial fly? - Isaak Walton",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_221905.jpg"
        },
        {
          id: 9,
          rubrik: "Glomma",
          text:
            "And finally, I fish not because I regard fishing as being terribly important, but because I suspect that so many of the other concerns of men are equally unimportant, and not nearly so much fun. - John Volker",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_212822.jpg"
        }
      ]
    };
  }
};
</script>
